import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { prepareCommonLinearData, sendLinear } from "~/features/configurator/Linear/api/sendLinearCommon";
import {
  prepareApiDataForResetNewest,
  prepareGroupIdToDisplay,
} from "~/features/configurator/common/commonConfiguratorApi";
import { UNIT_CONFIGURATOR_PRODUCT_CODE } from "~/domains/configurator/constants";
import { StandardKits } from "../../Carriage/v2/configuration/CarriageCstics";

export function sendLinearDataReset(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const data = prepareCommonLinearData(linearState);
  // TODO: Check if reset in all steps works correctly after this change
  const resetData = prepareApiDataForResetNewest(linearState);

  if (linearState.productCode === UNIT_CONFIGURATOR_PRODUCT_CODE && linearState.currentStep === 6) {
    // We need to send reset for KITS, which is "S" and not null...

    (resetData.groups ?? [])
      .filter((group) => group.subGroups)
      .forEach(
        (group) =>
          group.subGroups?.forEach(
            (subGroup) =>
              subGroup.cstics?.forEach((cstic) => {
                if (cstic.key.includes(StandardKits)) {
                  cstic.value = "S";
                }
              }),
          ),
      );
  }

  prepareGroupIdToDisplay(data);

  return sendLinear({
    ...data,
    ...resetData,
  });
}
